import { render, staticRenderFns } from "./AppManagerView.vue?vue&type=template&id=bb01118c&scoped=true&"
import script from "./AppManagerView.vue?vue&type=script&lang=ts&"
export * from "./AppManagerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb01118c",
  null
  
)

export default component.exports